
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"19","viewBox":"0 0 14 19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.74763 16.7871C7.44221 17.08 7.18534 17.3145 7 17.4798C6.81465 17.3145 6.55779 17.08 6.25237 16.7871C5.60575 16.1668 4.74471 15.2873 3.88506 14.2495C3.02426 13.2103 2.17297 12.022 1.53872 10.7844C0.902828 9.54352 0.5 8.2819 0.5 7.08765C0.5 3.52802 3.40241 0.642822 7 0.642822C10.5976 0.642822 13.5 3.52802 13.5 7.08765C13.5 8.2819 13.0972 9.54352 12.4613 10.7844C11.827 12.022 10.9757 13.2103 10.1149 14.2495C9.25529 15.2873 8.39425 16.1668 7.74763 16.7871Z","stroke":"#8D8D8D"}}),_c('circle',{attrs:{"cx":"6.95452","cy":"6.9804","r":"3.18182","stroke":"#8D8D8D"}})])
          )
        }
      }
    